import React, { useEffect } from 'react';
import BSLABasemapWidget from './BSLABasemapWidget';
import BSLAHomeWidget from './BSLAHomeWidget';
import BSLAMeasureWidget from './BSLAMeasureWidget';
import BSLALocateWidget from './BSLALocateWidget';
import BSLASearchWidget from './BSLASearchWidget';
import BSLALayerList from './BSLALayerListWidget';
import BSLAScreenshotWidget from './BSLAScreenshotWidget';

interface ICFWidgetsProps {
    view?: __esri.MapView | __esri.SceneView;
    map?: __esri.Map;
}

const topLeft = async (view: __esri.MapView | __esri.SceneView) => {
    const home = await BSLAHomeWidget(view);
    const locate = await BSLALocateWidget(view);
    const basemapGallery = await BSLABasemapWidget(view);
    const screenshot = BSLAScreenshotWidget({ view });
    view.ui.add([home, screenshot, locate, basemapGallery], 'top-left');
};

const topRight = async (view: __esri.MapView | __esri.SceneView) => {
    const searchWidget = await BSLASearchWidget(view);

    view.ui.add([searchWidget], 'top-right');
};

const bottomRight = async (view: __esri.MapView | __esri.SceneView) => {
    const measureWidget = await BSLAMeasureWidget(view);

    view.ui.add([measureWidget], 'bottom-right');
};

const bottomLeft = async (view: __esri.MapView | __esri.SceneView) => {
    const layerList = await BSLALayerList(view);

    view.ui.add([layerList], 'bottom-left');
};

const BSLAWidgets: React.FC<ICFWidgetsProps> = (props) => {
    useEffect(() => {
        if (props.view) {
            const view = props.view;
            const init = () => {
                view.when(async () => {
                    // Top Left Widgets
                    topLeft(view);

                    // Bottom Left Widgets
                    bottomLeft(view);

                    // Bottom Right Widgets
                    bottomRight(view);

                    // Top Right Widgets
                    topRight(view);
                });
            };

            init();
        }
    }, [props.view]);
    return null;
};

export default BSLAWidgets;
